//Componentes generales
import React, { useReducer, useContext, useEffect } from "react";
import controlReducer from "./controlReducer";
import controlContext from "./controlContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getProductsByTDocNroFor } from "../../api/product";
import {
  getTDocsByUserIdAndParams,
  getTransactionDocumentsByTDocCodForAndParams,
} from "../../api/transactionDocument";
import { getAllUsers, getUsersInGroupV } from "../../api/user";
import { getAbmReqSector } from "../../api/abmReqSector";

//Socket
import { SocketContext } from "../socket/socket";

//Acciones
import {
  ACTUALIZAR_TDOC,
  AGREGAR_TDOC,
  MODIFICAR_FILTROS_ESTADOS,
  MODIFICAR_FILTROS_RANGO,
  INICIAR_FILTROS,
  SET_INICIAR_FILTROS_IS_LOADING,
  SET_ACTIVE_WORKSPACE,
} from "./controlActions";

//Estados de autorización
import { STATES } from "../../utils/states";
import { filtrosToString } from "../../utils/funciones";

//Valores iniciales
const initialState = {
  listTDoc: null,
  filtrosRango: {
    fchMov: {
      desde: moment.utc().subtract(365, "days").startOf('day').toDate(),
      hasta: moment.utc().endOf('day').toDate(), // 23:59:59
    },
    deliveryDate: moment.utc().add(30, "days").endOf('day').toDate(),
  },
  filtrosEstado: {
    state: [],
    priority: [0, 1, 2],
    userName: [],
    tDocAbmReqSector: [{}],
    prodsConPrecio: true,
    prodsSinPrecio: false,
  },
  filtrosEstadoPredeterminado: null,
  cargando: false,
  iniciarFiltrosIsLoading: false,
  activeWorkSpace: {
    pendientes: 1,
    enEspera: 0,
    autorizados: 0,
    todos: 0,
  },
};

/* 
    State encargado de la gestión de filtros y listado de requerimientos. (No se encuentra tan en uso, en la mayoria fue reemplazado por controlGLB).
*/
const ControlState = (props) => {
  const server = useContext(SocketContext);

  /* 
        Disparadores que sincronizan la lista de requerimientos ante la creación de un requerimiento.
    */
  useEffect(() => {
    if (server) {
      //TDoc Nuevo
      server.on("addTDoc", (tDoc) => {
        console.log("RECIBO EL TDOC CREADO");
        dispatch({
          type: AGREGAR_TDOC,
          payload: tDoc,
        });
      });

      return () => server.off("addTDoc");
    }
  }, [server]);

  /* 
        Disparadores que sincronizan la lista de requerimientos ante la modificación de un requerimiento.
    */
  useEffect(() => {
    if (server) {
      //TDoc Modificado
      server.on("modTDoc", ({ tDoc }) => {
        dispatch({
          type: ACTUALIZAR_TDOC,
          payload: tDoc,
        });
      });

      return () => server.off("modTDoc");
    }
  }, [server]);

  const [state, dispatch] = useReducer(controlReducer, initialState);

  //Logica del control state;

  //Inicializa los filtros dependiendo del usuarios y del comprobante seleccionado
  const iniciarFiltros = async (activeWorkSpace, usuario = "") => {
    // Indicar que los filtros están siendo reiniciados para evitar parpadeo
    dispatch({
      type: SET_INICIAR_FILTROS_IS_LOADING,
      payload: true,
    });

    try {
      console.log("Entra en inciar Filtros");
      //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
      const filtrosString = filtrosToString(initialState.filtrosRango);

      //Relizo peticion con los parametros de rango y el usuario en sesion
      const resp = await getTDocsByUserIdAndParams(usuario._id, filtrosString);
      let tDocs = [];
      tDocs = [...resp.data.data];

      //Obtengo los usuarios que puede ver el usuario mediante su campo groupV
      const respUsuarios = await getUsersInGroupV(usuario._id);
      //console.log(respUsuarios);
      //const usuarios = respUsuarios.data.data.map((u) => u.user.userName);
      //Creo un arreglo de userNames y luego si no se encuentra el usuario en sesion lo agrego
      const usuarios = [
        ...new Set(respUsuarios.data.data.map((u) => u.user.userName)),
      ];
      console.log(usuarios);
      if (!usuarios.includes(usuario.userName)) usuarios.push(usuario.userName);
      //Obtengo los Sectores de Requerimientos
      const respSectoresRequerimientos = await getAbmReqSector();
      const sectoresRequerimientos = respSectoresRequerimientos.data.data.map(
        (sR) => ({
          codSem: sR.codSem,
          descrp: sR.descrp,
        })
      );
      sectoresRequerimientos.push({ codSem: "", descrp: "" });

      let state = [];
      if (activeWorkSpace.todos == 1) {
        state = STATES;
      } else if (activeWorkSpace.pendientes == 1) {
        state = ["PENDIENTE"];
      } else if (activeWorkSpace.enEspera == 1) {
        state = ["EN ESPERA"];
      }else if (activeWorkSpace.autorizados == 1) {
        state = ["AUTORIZADO"];
      }

      const filtrosEstado = {
        ...initialState.filtrosEstado,
        state: state,
        userName: usuarios,
        tDocAbmReqSector: sectoresRequerimientos,
      };

      const filtrosRango = { ...initialState.filtrosRango };

      dispatch({
        type: INICIAR_FILTROS,
        payload: {
          tDocs: tDocs,
          filtrosEstado: filtrosEstado,
          filtrosRango: filtrosRango,
        },
      });

      dispatch({
        type: MODIFICAR_FILTROS_RANGO,
        payload: { filtrosRango, tDocs },
      });

      // Indicar que los filtros terminaron de cargarse
      dispatch({
        type: SET_INICIAR_FILTROS_IS_LOADING,
        payload: false,
      });
    } catch (error) {
      console.log(error);
      console.log("Error a la hora de iniciar filtros");
      // Indicar que los filtros terminaron de cargarse incluso en caso de error
      dispatch({
        type: SET_INICIAR_FILTROS_IS_LOADING,
        payload: false,
      });
    }
  };

  //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
  const modificarFiltrosRango = async (userId, filtrosRango) => {
    const filtrosString = filtrosToString(filtrosRango);

    const resp = await getTDocsByUserIdAndParams(userId, filtrosString); //clienteAxios.post('/transactionDocument/filter', filtrosRango);

    let tDocs = [];

    tDocs = [...resp.data.data];

    dispatch({
      type: MODIFICAR_FILTROS_RANGO,
      payload: { filtrosRango, tDocs },
    });
  };

  //Modifica los filtros de estado
  const modificarFiltrosEstado = (filtrosEstados) => {
    dispatch({
      type: MODIFICAR_FILTROS_ESTADOS,
      payload: filtrosEstados,
    });
  };

  //Filtra una lista de tDoc de acuerdo a los filtros

  const filtrar = (lista, filtrosEstado) => {
    console.log("Entra a la función filtar");
    if (
      !lista ||
      lista === undefined ||
      state.filtrosEstado.userName === undefined
    )
      return [];

    const listaFiltrada = lista.filter(
      (item) =>
        filtrosEstado.state.includes(item.state) &&
        filtrosEstado.priority.includes(item.priority) &&
        filtrosEstado.userName
          .map((name) => name && name.toUpperCase())
          .includes(item?.userName.toUpperCase()) &&
        filtrosEstado.tDocAbmReqSector
          .map((reqSector) => reqSector.codSem)
          .includes(item.tDocAbmReqSectorCodsem)
    );

    if (!filtrosEstado.prodsConPrecio && !filtrosEstado.prodsSinPrecio) {
      return [];
    }

    if (filtrosEstado.prodsConPrecio && filtrosEstado.prodsSinPrecio) {
      return listaFiltrada;
    }

    if (filtrosEstado.prodsConPrecio) {
      return listaFiltrada.filter((item) => !item.pricelessProds);
    }

    if (filtrosEstado.prodsSinPrecio) {
      return listaFiltrada.filter((item) => item.pricelessProds === true);
    }

    return listaFiltrada;
  };

  //Auxiliar
  const getProductsByNroFor = async (tDocCodFor, tDocNroFor) => {
    try {
      const resp = await getProductsByTDocNroFor(tDocCodFor, tDocNroFor); //clienteAxios.get(`/productBytDocNroFor/${tDocCodFor}/${tDocNroFor}`);
      return resp.data.data;
    } catch (error) {
      console.log(error.response);
    }
  };

  //Modifica el workspace activo
  const setActiveWorkSpace = (workspace) => {
    dispatch({
      type: SET_ACTIVE_WORKSPACE,
      payload: workspace,
    });
  };

  return (
    <controlContext.Provider
      value={{
        listTDoc: state.listTDoc,
        cargando: state.cargando,
        filtrosEstado: state.filtrosEstado,
        filtrosRango: state.filtrosRango,
        iniciarFiltrosIsLoading: state.iniciarFiltrosIsLoading,
        activeWorkSpace: state.activeWorkSpace,
        iniciarFiltros,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        filtrar,
        getProductsByNroFor,
        setActiveWorkSpace,
      }}
    >
      {props.children}
    </controlContext.Provider>
  );
};

export default ControlState;